module.exports = __webpack_public_path__ + "static/media/i5.f2d18d22.png";